<template>
    <el-dialog
        :visible.sync="cancelScoreFlag"
        width="25%"
        top="15%"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div slot="title" class="header-title">
           <span>成绩作废原因</span>
        </div>
        <div class="msgContent">
          <el-input
            type="textarea"
            placeholder="输入文字"
            v-model="reason"
            maxlength="200"
            show-word-limit
            resize="none"
            rows="8"
            class="inputResult"
            >
          </el-input>
        </div>  
        <div slot="footer" class="dialog-footer">
          <el-button  @click="showHideCancelScoreDialog(false)">取 消</el-button>
          <el-button class="determine" @click="confirm">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
  export default {
    data() {
      return {
        cancelScoreFlag: false,
        reason:''

      };
    },
    props:{
      value:Boolean,
      studentId:String
    },

    watch:{
      value:function(){
        this.reason=''
          this.cancelScoreFlag=this.value
      },
    },
    methods:{
      showHideCancelScoreDialog: function(flag){
        this.cancelScoreFlag = flag
        this.$emit('cancel') 
      },
      confirm:function(){
        let params={
          reExamOrderId:this.studentId,
          invalidateReason:this.reason
        }
        this.$http.delete(`/examination/cancel/score`, {params}).then((res) => {
          if (res.data.success) {
            this.$emit('saveCallBack') 
            this.showHideCancelScoreDialog(false)
            this.$message.success('编辑成功！'); 
          } 
        })
      },
    }   
  };
</script>
<style scoped>
.header-title{
    padding: 20px 0 0 0;
    font-size: 34px;
    font-weight:bold;
    text-align: center;
    
}
::v-deep  .el-dialog__body {
  padding: 20px 30px 0 30px;
}
::v-deep .inputResult .el-textarea__inner{
    background-color: #F5F5F5;
    border: none;
    padding: 14px;
}
::v-deep .el-dialog__footer{
    width: 100%;
    padding: 0;
    margin-top:30px;
    border-top: 2px solid #EDEDED;
}
.dialog-footer{
    width: 100%;
    display:flex;
    height: 120px;
}

.determine{
    color: #54B0FB;
}
.dialog-footer /deep/ .el-button{
  margin: 0;
    padding: 0;
    width: 50%;
    border-radius: 0;
    border: none;
    border-right: 2px solid #EDEDED;
  font-size: 16px;
}

</style>